import { FilterTemplate } from "@/models/Filter";

export class Rule {
  public constructor(
    public Left: FilterTemplate,
    public Opertator: string,
    public Right: FilterTemplate,
    public DiffMin: number,
    public DiffMax: number
  ) {
  } 
}